module.exports = __webpack_public_path__ + "img/university1.8597cd8b.png";